// extracted by mini-css-extract-plugin
module.exports = {"snippet-wrapper":"html-snippet-m__snippet-wrapper__2175v"};